import React from 'react';

import { Select } from '@aline/common';
import { useMediaQuery, useTheme } from '@mui/material';
import { AlineButton } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { useCurrentUserQuery } from 'src/gql/hooks';

import { SigningOutcomeCard, SigningOutcomePage, useGoToAline } from './SigningOutcomePage';

/**
 * Where a signer lands after handing their signature request to someone else. The document is no
 * longer theirs to act on, so this replaces the editor rather than dropping them back into it.
 */
export function WorkflowReassigned() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { currentUser } = useCurrentUserQuery();
  const isInternalUser = currentUser?.loginType !== Apollo.LoginType.Passwordless;
  const handleGoToAline = useGoToAline(isInternalUser);

  return (
    <SigningOutcomePage
      dataCy={Select.document.editor.walkthrough.reassignedPage}
      showAboutAline={!isInternalUser}
      title="Reassigned"
    >
      <SigningOutcomeCard
        primaryText="Signer reassigned"
        secondaryText="We've emailed the new signer a link to sign. Nothing more is needed from you."
      >
        <AlineButton
          color="primary"
          fullWidth={isMobile}
          variant="outlined"
          onClick={handleGoToAline}
        >
          Go to Aline
        </AlineButton>
      </SigningOutcomeCard>
    </SigningOutcomePage>
  );
}
